import axiosClient from "./axiosClient";

export class MetaCatalogConnectionApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = "MetaCatalogConnectionApiError";
    this.status = status;
    this.code = code;
  }
}

async function request(config) {
  try {
    const response = await axiosClient(config);
    const envelope = response?.data ?? {};
    if ((envelope.success ?? envelope.Success) === false) {
      throw new MetaCatalogConnectionApiError(
        envelope.message ?? envelope.Message ?? "Meta catalogue request failed.",
        response?.status,
        envelope?.data?.code ?? envelope?.Data?.Code,
      );
    }
    return envelope.data ?? envelope.Data ?? envelope.payload ?? envelope.Payload ?? envelope;
  } catch (error) {
    if (error instanceof MetaCatalogConnectionApiError) throw error;
    const envelope = error?.response?.data ?? {};
    throw new MetaCatalogConnectionApiError(
      envelope.message ?? envelope.Message ?? "Meta catalogue request failed. Please try again.",
      error?.response?.status,
      envelope?.data?.code ?? envelope?.Data?.Code,
    );
  }
}

export const metaCatalogConnectionApi = {
  getStatus: () => request({ method: "get", url: "/meta-catalog-connection/status" }),
  startAuthorization: returnPath =>
    request({
      method: "post",
      url: "/meta-catalog-connection/authorize",
      data: { returnPath },
    }),
  listCatalogues: () =>
    request({ method: "get", url: "/meta-catalog-connection/catalogues" }),
  selectCatalogue: (catalogId, expectedVersion) =>
    request({
      method: "post",
      url: "/meta-catalog-connection/select",
      data: { catalogId, expectedVersion },
    }),
  disconnect: expectedVersion =>
    request({
      method: "post",
      url: "/meta-catalog-connection/disconnect",
      data: { expectedVersion },
    }),
  listProducts: (pageSize = 25, after) =>
    request({
      method: "get",
      url: "/meta-catalog-connection/products",
      params: { pageSize, ...(after ? { after } : {}) },
    }),
  createProduct: product =>
    request({ method: "post", url: "/meta-catalog-connection/products", data: product }),
  updateProduct: (productId, product) =>
    request({
      method: "put",
      url: `/meta-catalog-connection/products/${encodeURIComponent(productId)}`,
      data: product,
    }),
  deleteProduct: productId =>
    request({
      method: "post",
      url: `/meta-catalog-connection/products/${encodeURIComponent(productId)}/delete`,
      data: { confirm: true },
    }),
};
